module.exports = {"410704001":"宝西街道","410704002":"宝东街道","410704100":"大块镇","410704101":"耿黄镇","410704200":"潞王坟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410704.json
// module id = 1452
// module chunks = 0